import { createSelector } from 'reselect';

const selectTenantWebsiteCards = (state: any) => state.tenantWebsiteCards;


export const selectTenantWebsiteCardsCurrentItem = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.current);

export const selectTenantWebsiteCardsListItems = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectTenantWebsiteCardsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTenantWebsiteCardsQueryItems = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.query);

export const selectTenantWebsiteCardsCreatedItem = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.create);

export const selectTenantWebsiteCardsUpdatedItem = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.update);

export const selectTenantWebsiteCardsReadItem = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.read);

export const selectTenantWebsiteCardsDeletedItem = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.delete);

export const selectTenantWebsiteCardsSearchedItems = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.search);

export const selectTenantWebsiteCardsItemsCount = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.count);

export const selectTenantWebsiteCardsItemsFilter = createSelector([selectTenantWebsiteCards], (tenantWebsiteCards) => tenantWebsiteCards.filter);